export enum CreditLineResultStatus {
    Declined = 'declined',
    Preapproved = 'preapproved',
    Approved = 'approved',
    Pending = 'pending',
    Canceled = 'canceled',
    OnHold = 'on-hold',
    NotEligeble = 'not-eligeble',
    Unknown = 'unknown',
    InReview = 'in-review',
    ManualReview = 'manual-review',
}
